var search = {
    pageSearchData: [],

    init: function () {
        var _self = this;
        $.ajax({
            url: '/working/' + epaperId + '/xml/search_' + revisionId + '.json',
            datatype: 'json',
            success: function (data) {
                pageSearchData = data;
            }
        });

        $('#search-container #search, #mobile-search').bind('input', function () {
            $('.search-highlight').remove();

            var str = $(this).val();

            if (str.length < 2) {
                return false;
            }
            _self.searchGlobal(str);

            // Setup page turning
            $('.goto').click(function() {
                goToPage($(this).attr('data-page'));
            });
        });
    },
    searchGlobal: function (str) {
        var _self = this;
        var matches = {};

        // Look through each page's content
        $.each(pageSearchData, function (i, page) {
            var regExp = new RegExp(str, 'gi');
            var match = [];

            while ((match = regExp.exec(page)) !== null) {
                match = match.index;
                if (typeof matches[i] === 'undefined') {
                    matches[i] = new Array();
                }
                var end = match >= 100 ? 100 : match;

                matches[i].push(page.substr(match - 100, end) + '<b>' + page.substr(match, str.length) + '</b>' + page.substr(match + str.length, 100));
            }
        });
        var pageNum = $('.magazine').turn('page');
        var pageId = allThePages[pageNum].id;
        var fileId = allThePages[pageNum].file_id;
        var result = _self.loadContent(matches);
        var content = result.content;

        _self.searchPage(pageId, str, pageNum, fileId);

        if (pageNum < epaperPageCount) {
            var nextPageId = allThePages[$('.magazine').turn('page') + 1].id;
            var nextFileId = allThePages[$('.magazine').turn('page') + 1].file_id;
            _self.searchPage(nextPageId, str, pageNum + 1, nextFileId);
        }

        _self.matches = result.matches;
        if (content === '') {
            content += '<br /><br /><b>' + searchMessageNoResult + '</b>';
        }
        $('#search-result .content').html(content);
        $('#search-result .jspPane').css('top', 0);
        $('#search-result').jScrollPane({mouseWheelSpeed: 30}).addClass('active');

        $.each(matches, function (i, match) {
            if (pageId === i) {
                this.searchPage(pageId, str, pageNum, fileId);
            } else if (nextPageId === i) {
                this.searchPage(nextPageId, str, pageNum + 1, fileId);
            }
        });

        var loading = false;
        $('#search-result').scroll(function () {
            var matches = _self.matches;
            if ($.isEmptyObject(matches)) {
                return;
            }
            var diff = ($('#search-result .content').height() + $('#search-result .jspPane').offset().top);

            if (diff < ($(window).height() - 100) && !loading) {
                loading = true;
                var result = _self.loadContent(matches);
                var content = result.content;
                _self.matches = result.matches;
                $('#search-result .content').append(content);
                $('#search-result').jScrollPane({mouseWheelSpeed: 30}).addClass('active');
                loading = false;
            }
        });
    },

    loadContent: function (matches) {
        var index = 10;
        var content = '';
        $.each(matches, function (page, res) {
            if (index == 0) {
                return;
            }
            content += '<div class="page goto" data-page="' + page + '">';
            content += '<div class="page-table">';
            content += '<div class="page-num">';
            content += searchMessagePage + ' ' + page;
            content += '</div>';
            content += '<div class="title">';
            content += res;
            content += '</div>';
            content += '</div>';
            content += '</div>';
            index--;
            delete matches[page];
        });
        var result = {
            content: content,
            matches: matches
        };

        return result;
    },

    searchStr: function (data, str, pageNum) {
        str = str.toLowerCase();
        str = str.replace(/\s/g, '', str);

        var maxErrors = Math.round(str.length * 0.2);
        for (var a = 0; a < data.length; a++) {
            var box = data[a];
            for (var b = 0; b < box.length; b++) {
                var line = box[b];
                for (var c = 0; c < line.length; c++) {
                    var letter = line[c];
                    if (letter.text.toLowerCase() === str[0]) {
                        var foundErrors = 0;

                        for (var i = 1; i < str.length; i++) {
                            // reached end of line
                            if (typeof line[c + i] === 'undefined') {
                                // check if text continues on next line
                                if (typeof box[b + 1] !== 'undefined' && typeof box[b + 1][c + i - line.length] !== 'undefined' && box[b + 1][c + i - line.length].text.toLowerCase() !== str[i]) {
                                    foundErrors += 1;
//									break;
                                } else if (typeof box[b + 1] === 'undefined' || typeof box[b + 1][c + i - line.length] === 'undefined') {
                                    // line is too short
                                    foundErrors += 1;
//									break;
                                }
                            } else {
                                // text does not match
                                if (line[c + i].text.toLowerCase() !== str[i]) {
                                    foundErrors += 1;
//									break;
                                }
                            }
                            if (foundErrors > maxErrors) {
                                break;
                            }
                        }

                        if (foundErrors < maxErrors) {
                            var firstLetter = line[c];
                            // hit continues on next line
                            if (line.length < c + str.length) {
                                var lastLetter = line[line.length - 1];
                                if (b + 1 < box.length) {
                                    var firstLetter2 = box[b + 1][0];
                                    var lastLetter2 = box[b + 1][c + str.length - 1 - line.length];
                                    this.drawHitHighlight(firstLetter2, lastLetter2, pageNum);
                                }
                            } else {
                                lastLetter = line[c + str.length - 1];
                            }
                            this.drawHitHighlight(firstLetter, lastLetter, pageNum);
                        }
                    }
                }
            }
        }
    },

    drawHitHighlight: function (firstLetter, lastLetter, pageNum) {
        var firstLetterCoods = firstLetter.bbox.split(',');
        var lastLetterCoods = lastLetter.bbox.split(',');

        var left = firstLetterCoods[0] * 100;
        var topPos = lastLetterCoods[1] * 100;

        var width = (lastLetterCoods[2] - firstLetterCoods[0]) * 100;
        var height = (lastLetterCoods[3] - firstLetterCoods[1]) * 100;

        var $link = $('<div class="region link search-highlight"></div>').appendTo($('.p' + pageNum));
        $link.css({height: height + '%', width: width + '%', bottom: topPos + '%', left: left + '%'});
    },

    searchPage: function (pageId, str, pageNum, fileId) {
        var url = '/working/' + epaperId + '/xml/' + fileId + '.json';
        var _self = this;

        $.ajax({
            url: url,
            datatype: 'json',
            cache:true,
            success: function (data) {
                _self.searchStr(data, str, pageNum);
            }
        });
    }
};